import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Chapter, Reveal, MarqueeStrip } from "@/components/motion";
import { IMAGES, SERVICES, MARQUEE_ITEMS } from "@/data/site";
import { cn } from "@/lib/utils";

const SERVICE_IMAGES = [IMAGES.civil, IMAGES.workforce, IMAGES.site, IMAGES.engineer, IMAGES.steel, IMAGES.bridge];

const SERVICE_DETAILS = [
  "Reliable general labour and site-support personnel, ready to integrate into your project environment from day one.",
  "Trades and experienced personnel matched to the specific skills, tickets and requirements of each project.",
  "Coordinated multi-personnel deployments with ongoing workforce coordination for projects of any scale.",
  "Flexible arrangements for immediate short-notice requirements through to longer-term operational needs.",
  "A dedicated management point of contact keeping personnel supported, compliant and aligned with your expectations.",
  "Increase or reduce workforce numbers in step with project demands, timelines and operational requirements.",
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        index="02"
        label="Our Services"
        titleLines={["Workforce Solutions", { t: "Designed for Construction.", c: "text-gold" }]}
        intro="Formcore provides flexible labour hire solutions designed to support the changing workforce requirements of construction projects — from individual personnel to large-scale workforce deployments."
        image={IMAGES.civil}
      />

      <section className="bg-white py-28 lg:py-32">
        <div className="mx-auto max-w-7xl space-y-24 px-6 lg:space-y-32">
          {SERVICES.map((service, i) => (
            <div key={service.title} className="grid items-center gap-12 lg:grid-cols-2" data-testid={`service-detail-${i}`}>
              <Reveal className={cn(i % 2 === 1 && "lg:order-2")}>
                <div className="relative">
                  <div className={cn("absolute hidden h-full w-full border-2 border-gold md:block", i % 2 === 1 ? "-left-5 -top-5" : "-bottom-5 -right-5")} />
                  <img
                    src={SERVICE_IMAGES[i]}
                    alt={service.title}
                    className="clip-frame relative h-[280px] w-full object-cover md:h-[400px]"
                  />
                </div>
              </Reveal>
              <div className={cn(i % 2 === 1 && "lg:order-1")}>
                <Reveal y={16} className="flex items-center gap-4">
                  <span className="font-heading text-sm font-bold text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <span className="h-px w-12 bg-gold" />
                  <span className="grid h-11 w-11 place-items-center bg-gold/10 text-gold">
                    <service.icon className="h-5 w-5" />
                  </span>
                </Reveal>
                <Reveal delay={0.1}>
                  <h2 className="mt-6 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
                    {service.title}
                  </h2>
                </Reveal>
                <Reveal delay={0.2}>
                  <p className="mt-5 text-base leading-relaxed text-charcoal/75">{service.text}</p>
                  <p className="mt-4 text-base leading-relaxed text-charcoal/60">{SERVICE_DETAILS[i]}</p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      <MarqueeStrip items={MARQUEE_ITEMS} dark />
      <CTASection title="Need Personnel for an Upcoming Project?" />
    </div>
  );
}
